<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="period">Периодичность (дней)</label>
    <input
      type="text"
      class="form-control"
      id="period"
      placeholder="Введите периодичность в днях"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'period-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Period.vue?d94274b8